import ApplicationController from '../application_controller.js'
import { Turbo } from '@hotwired/turbo-rails'

export default class extends ApplicationController {
  static targets = [
    'blockOrder',
    'volume',
    'volumeHour',
    'powerPlant',
    'date',
    'timeFrom',
    'timeTo',
    'turboFrame'
  ]

  connect() {
    this.originalTimeOptions = {
      timeFrom: Array.from(this.timeFromTarget.options),
      timeTo: Array.from(this.timeToTarget.options)
    }
    this.loadDetails()
  }

  loadDetails() {
    const powerPlantUuid = this.powerPlantTarget.value
    const block_order_id = this.blockOrderTarget.value
    const date = this.dateTarget.value
    const timeFrom = this.timeFromTarget.value
    const timeTo = this.timeToTarget.value

    if (powerPlantUuid && timeFrom && timeTo && date) {
      Turbo.visit(
        `/block_orders/profile_details?block_order_id=${block_order_id}&power_plant_uuid=${powerPlantUuid}&date=${date}&time_from=${timeFrom}&time_to=${timeTo}`,
        { frame: 'profile-details', updateHistory: false, historyChanged: true }
      )
    }
  }

  updateTimeOptions() {
    const selectedTime = this.timeFromTarget.value // Get the selected value from "timeFrom"

    if (selectedTime) {
      this.filterOptions(this.timeToTarget, Number(selectedTime))
    } else {
      this.restoreOriginalOptions(this.timeToTarget, 'timeTo')
    }

    this.loadDetails()
  }

  filterOptions(targetElement, limitTime) {
    const currentValue = targetElement.value
    const currentValueNumber = Number(currentValue)
    const options = this.originalTimeOptions.timeTo

    targetElement.innerHTML = ''

    let foundCurrentValue = false
    options.forEach((option) => {
      const optionTime = option.value
      const optionTimeNumber = Number(optionTime)
      if (optionTime > limitTime) {
        targetElement.add(option.cloneNode(true))
        if (optionTimeNumber === currentValueNumber) {
          foundCurrentValue = true
        }
      }
    })

    if (foundCurrentValue) {
      targetElement.value = currentValue
    } else {
      targetElement.value = ''
    }
  }

  restoreOriginalOptions(targetElement, type) {
    const currentValue = targetElement.value
    targetElement.innerHTML = ''
    let foundCurrentValue = false

    this.originalTimeOptions[type].forEach((option) => {
      targetElement.add(option.cloneNode(true))
      if (option.value === currentValue) {
        foundCurrentValue = true
      }
    })

    if (foundCurrentValue) {
      targetElement.value = currentValue
    } else {
      targetElement.value = ''
    }
  }

  onProfileVolumeChange() {
    this.fillVolumes(true)
  }

  onHourVolumeChange(e) {
    if (e.target.value !== this.volumeTarget.value) {
      this.volumeTarget.value = ''
      new Set(
        this.volumeHourTargets.filter((e) => e.value !== '').map((e) => e.value)
      ).size === 1
        ? (this.volumeTarget.value = this.volumeHourTargets[0].value)
        : (this.volumeTarget.value = '')
    }
  }

  fillVolumes(override = false) {
    const volumeValue = this.volumeTarget.value
    this.volumeHourTargets.forEach((e) => {
      if ((override && volumeValue !== '') || e.value == null) {
        e.value = volumeValue
      }
    })
  }
}
